import React, { useEffect, useState } from "react";
import { useNavigate, useParams , useLocation } from "react-router-dom";
import { getClubBusinessMemberOffers, updateBenefit } from "../../../_services/user.service";
import { toast } from "react-toastify";
import { isValid } from "../../../Validations/validation";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import "./ManageBenefitzFinal.css";
import NoBenefit from "../NoBenefit/NoBenefit";

export default function ManageBenefitzFinal() {
    const navigate = useNavigate();
    const params = useParams();
    const clubBusinessMember = JSON.parse(localStorage.getItem("clubBusinessMember")); ;
    const [offers, setOffers] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isUpdating, setIsUpdating] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        getClubBusinessMemberBenefits();
    }, []);

    const getClubBusinessMemberBenefits = async () => {
        try {
            let benefitsList = await getClubBusinessMemberOffers(clubBusinessMember.id);
            console.log("benefit list: " + benefitsList);
            const updatedOffers = benefitsList.map((offer) => ({
                ...offer,
                isEditing: false,
                isLoading: false,
                originalValues: { ...offer }
            }));
            setOffers(updatedOffers);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const toggleEdit = (index) => {
        const updatedOffers = offers.map((offer, i) => {
            if (i === index) {
                if (offer.isEditing) {
                    return { ...offer, ...offer.originalValues, isEditing: false };
                } else {
                    return { ...offer, originalValues: { ...offer }, isEditing: true };
                }
            }
            return offer;
        });
        setOffers(updatedOffers);
    };

    const updateData = async (offerIndex) => {
        try {
            const updatedOffers = [...offers];
            setIsUpdating(true);
            updatedOffers[offerIndex].isLoading = true;
            setOffers(updatedOffers);

            const offer = updatedOffers[offerIndex];
            const updatedData = {
                price: offer.price,
                points: offer.points,
                discountAmount: offer.discountAmount,
                description: offer.description,
                longDescription: offer.longDescription,
            };
            await updateBenefit(clubBusinessMember.clubId, offer.id, updatedData);
            toast("Saved Successfully");
            updatedOffers[offerIndex].isEditing = false;
            updatedOffers[offerIndex].isLoading = false;
            setOffers(updatedOffers);
        } catch (error) {
            console.error("Failed to update", error.message);
            updatedOffers[offerIndex].isLoading = false;
        } finally {
            setIsUpdating(false);
        }
    };

    const handleError = (error) => {
        console.log(error);
        console.log(error.details[0].message);

        const fields = ["price", "points", "discountAmount"];
        let errorField = "Description and Long Description";

        if (fields.some(field => {
            if (error.details[0].message.includes(field)) {
                errorField = field;
                if (errorField === "discountAmount") {
                    alert("Discount Amount must be a number and larger than 0");
                } else {
                    alert(`${errorField} must be a number and larger than 0`);
                }
                return true;
            }
            return false;
        })) {
            return;
        } else {
            alert(`${errorField} must be a text`);
        }
    };

    function handleBenefitInputs(fieldKey, field, index) {
        return (
            <input
                className="editable-input"
                value={fieldKey}
                onChange={(evnt) =>
                    setOffers((prev) =>
                        prev.map((myElement, i) =>
                            i === index
                                ? { ...myElement, [field]: evnt.target.value }
                                : myElement
                        )
                    )
                }
            />
        );
    }

    return (
        <div className="benefits-container">
            {!isLoading && offers.length > 0 && (
                <button
                    className="manage-benefits-add-button"
                    onClick={() => {
                        navigate(`/home/ManageClubs/${clubBusinessMember.id}/benefits-explained`);
                    }}
                >
                    <Plus className="button-icon" />
                    {t('addBenefit')}
                </button>
            )}

            {!isLoading && offers.length === 0 ? (
                <NoBenefit />
            ) : isLoading ? (
                null
            ) : (
                <div className="benefits-grid">
                    {offers.map((offer, index) => (
                        <div key={offer.id} className="benefit-card">
                            <div className="benefit-content">
                                <div className="benefit-header">
                                    <h3>{offer?.type}</h3>
                                    <button
                                        className="edit-btn"
                                        onClick={() => navigate(`/home/ManageClubs`)}
                                    >
                                        {t('backToClub')}
                                    </button>
                                </div>
                                <div className="benefit-details">
                                    <div className="detail-item">
                                        <span className="detail-label">{t('price')}</span>
                                        <span className="detail-value">
                                            {offer.isEditing
                                                ? handleBenefitInputs(offer.price, "price", index)
                                                : offer?.price}
                                        </span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">{t('points')}</span>
                                        <span className="detail-value">
                                            {offer.isEditing
                                                ? handleBenefitInputs(offer.points, "points", index)
                                                : offer?.points}
                                        </span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">{t('discountAmount')}</span>
                                        <span className="detail-value">
                                            {offer.isEditing
                                                ? handleBenefitInputs(offer.discountAmount, "discountAmount", index)
                                                : offer?.discountAmount}
                                        </span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">{t('description')}</span>
                                        <span className="detail-value">
                                            {offer.isEditing
                                                ? handleBenefitInputs(offer.description, "description", index)
                                                : offer?.description}
                                        </span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">{t('longDescription')}</span>
                                        <span className="detail-value">
                                            {offer.isEditing
                                                ? handleBenefitInputs(offer.longDescription, "longDescription", index)
                                                : offer?.longDescription}
                                        </span>
                                    </div>
                                    <div>
                                        <button
                                            className={`edit-btn ${offer.isLoading ? "loading-btn" : offer.isEditing ? "editing-btn" : "default-btn"}`}
                                            onClick={() => toggleEdit(index)}
                                            disabled={offer.isLoading}
                                        >
                                            {offer.isEditing ? "Cancel" : t('editBenefit')}
                                        </button>
                                        <button
                                            className={`save-btn ${!offer.isEditing ? "btn-disabled" : ""} ${offer.isLoading ? "loading-btn" : "normal-btn"}`}
                                            onClick={() => {
                                                const { error } = isValid({
                                                    price: Number(offers[index].price),
                                                    points: Number(offers[index].points),
                                                    discountAmount: Number(offers[index].discountAmount),
                                                    description: offers[index].description,
                                                    longDescription: offers[index].longDescription,
                                                });
                                                if (error) {
                                                    handleError(error);
                                                    return;
                                                }
                                                updateData(index);
                                            }}
                                            disabled={offer.isLoading && isUpdating}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="image-section">
                                <img
                                    className="benefit-image"
                                    src={offer?.smallPicturlUrl}
                                    alt={offer?.type}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
